module.exports = {"company":"Bedrijf","companies":"Berijven","name":"Naam","vat_number":"BTW nummer","list":{"title":"Bedrijven"},"manage":{"edit":"Bedrijf gegevens wijzigen","create":"Bedrijf aanmaken","addresses":"Adressen","address":{"country":"Land","postcode":"Postcode","city":"Gemeente","street":"Straat","number":"Huisnummer/bus"}},"address":{"select":"Selecteer een adres","create_new":"Een nieuwe adres toevoegen","list":{"empty":"Geen adressen gevonden"}}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/company.json
// module id = pYR/
// module chunks = 15